import React from 'react';
import NavBar from '../NavBar';
import Footer from '../Footer';
import '../../../styles/LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <NavBar />

      <main className="legal-container">
        <section className="legal-hero">
          <span className="legal-badge">TERMS OF SERVICE</span>

          <h1>
            Terms of <span>Service</span>
          </h1>

          <p>
            Please read these terms carefully before using DEFilms.
          </p>
        </section>

        <section className="legal-content">

          <div className="legal-section">
            <h2>1. Acceptance of Terms</h2>

            <p>
              Welcome to <strong>DEFilms</strong>. By accessing or using
              <strong> https://defilms.online/</strong>, you acknowledge that
              you have read, understood, and agreed to these Terms of Service.
            </p>

            <p>
              If you do not agree with these terms, please discontinue using
              the website.
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Use of the Website</h2>

            <p>
              DEFilms provides movie and TV series information, references,
              and entertainment-related features.
            </p>

            <p>
              Users agree to use the website responsibly and in accordance
              with applicable laws and regulations.
            </p>
          </div>

          <div className="legal-section">
            <h2>3. Movie Information</h2>

            <p>
              Information displayed on DEFilms may include movie titles,
              descriptions, genres, release dates, cast information, ratings,
              posters, images, and other metadata.
            </p>

            <p>
              Some information may be provided through third-party APIs or
              external data sources.
            </p>

            <p>
              DEFilms does not guarantee that all information is always
              accurate, complete, current, or error-free.
            </p>
          </div>

          <div className="legal-section">
            <h2>4. Third-Party Services</h2>

            <p>
              DEFilms may use or link to third-party services, APIs, embedded
              content, and external resources.
            </p>

            <p>
              Third-party services operate independently and may have their
              own terms, privacy policies, and rules.
            </p>

            <p>
              DEFilms is not responsible for the availability, content,
              security, policies, or practices of third-party services.
            </p>
          </div>

          <div className="legal-section">
            <h2>5. Intellectual Property</h2>

            <p>
              Movie titles, characters, trademarks, logos, posters, images,
              videos, and other copyrighted materials may belong to their
              respective copyright owners.
            </p>

            <p>
              Nothing on DEFilms should be interpreted as a claim of ownership
              over materials belonging to third parties.
            </p>
          </div>

          <div className="legal-section">
            <h2>6. Prohibited Activities</h2>

            <p>Users must not use DEFilms to:</p>

            <ul>
              <li>
                Conduct activities that violate applicable laws.
              </li>

              <li>
                Attempt to gain unauthorized access to the website or server.
              </li>

              <li>
                Interfere with or disrupt the operation of DEFilms.
              </li>

              <li>
                Introduce malicious software, scripts, or harmful code.
              </li>

              <li>
                Perform activities that place excessive load on the server.
              </li>

              <li>
                Use the website to infringe the rights of other individuals
                or organizations.
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>7. Website Availability</h2>

            <p>
              We make reasonable efforts to keep DEFilms available and
              operational.
            </p>

            <p>
              However, the website may occasionally experience downtime,
              maintenance, technical problems, updates, or interruptions.
            </p>

            <p>
              DEFilms does not guarantee uninterrupted availability of the
              website.
            </p>
          </div>

          <div className="legal-section">
            <h2>8. External Websites</h2>

            <p>
              DEFilms may provide links to external websites or services.
            </p>

            <p>
              We do not control and are not responsible for the content,
              security, privacy policies, or practices of external websites.
            </p>
          </div>

          <div className="legal-section">
            <h2>9. Changes to the Service</h2>

            <p>
              DEFilms reserves the right to modify, update, suspend, or
              discontinue any part of the website or its features at any time.
            </p>
          </div>

          <div className="legal-section">
            <h2>10. Changes to These Terms</h2>

            <p>
              These Terms of Service may be updated from time to time.
            </p>

            <p>
              Updated terms will be published on this page. Continued use of
              DEFilms after changes are published constitutes acceptance of
              the updated terms.
            </p>
          </div>

          <div className="legal-section">
            <h2>11. Contact</h2>

            <p>
              If you have questions regarding these Terms of Service, please
              contact the DEFilms team.
            </p>

            <a
              href="/contact"
              className="legal-contact-link"
            >
              Contact Us
            </a>
          </div>

          <div className="legal-contact-card">
            <h3>Thank You</h3>

            <p>
              Thank you for using DEFilms. Please use the website responsibly
              and respect the rights of content owners and other users.
            </p>
          </div>

        </section>

        <div className="legal-updated">
          Last updated: September 21, 2026
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;